const compareSize = (a, b) => {
    const sizeLevel = {
        'XS': 1,
        'S': 2,
        'M': 3,
        'L': 4,
        'XL': 5,
        '2XL': 6,
        '3XL': 7,
        '4XL': 8,
        '5XL': 9,
        '6XL': 10
    }
    const levelA = sizeLevel[a] || 0
    const levelB = sizeLevel[b] || 0

    if (levelA > levelB) return 1
    if (levelA < levelB) return -1
    if (a > b) return 1
    if (a < b) return -1

    return 0
}

export default compareSize
